/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkForexConversionPayload } from '../models/BulkForexConversionPayload';
import type { ForexConversionPayload } from '../models/ForexConversionPayload';
import type { ForexConversionResponse } from '../models/ForexConversionResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ForexService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Exchange Rate For As Of Date
     * @param requestBody
     * @returns ForexConversionResponse Successful Response
     * @throws ApiError
     */
    public getExchangeRateForAsOfDate(
        requestBody: ForexConversionPayload,
    ): CancelablePromise<ForexConversionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/forex/get-exchange-rate-for-as-of-date',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Exchange Rate By As Of Date
     * @param requestBody
     * @returns ForexConversionResponse Successful Response
     * @throws ApiError
     */
    public getExchangeRateByAsOfDate(
        requestBody: BulkForexConversionPayload,
    ): CancelablePromise<Record<string, ForexConversionResponse>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/forex/get-exchange-rate-by-as-of-date',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
